<template>
  <div class="legal-container">
    <h1>DRAFT</h1>
    <h1>Privacy Policy</h1>
    <p>Last Updated: February 23, 2026</p>

    <section>
      <h2>1. Our Commitment to Sovereignty</h2>
      <p>AppWafn is built on the principle of Data Sovereignty. Unlike traditional platforms, we do not use US-based "Big Tech" managed services. Your data is stored on private infrastructure located in Montreal, Quebec (OVHcloud), ensuring your information remains under Canadian jurisdictional protection.</p>
    </section>

    <section>
      <h2>2. Information We Collect</h2>
      <ul>
        <li><strong>Account Data:</strong> Name, email, and phone number required for authentication.</li>
        <li><strong>Payment Data:</strong> We use Helcim to tokenize and vault your payment information. We never store your full credit card number on our servers.</li>
        <li><strong>User Content:</strong> Images and files you upload are stored in a private, encrypted object storage bucket in our sovereign infrastructure.</li>
      </ul>
    </section>

    <section>
      <h2>3. How We Use Your Data</h2>
      <p>We use your data strictly to provide the services of AppWafn, including:</p>
      <ul>
        <li>Authenticating your access.</li>
        <li>Facilitating marketplace connections.</li>
        <li>Processing subscription billing.</li>
        <li>Sending essential system notifications (via Mailjet).</li>
      </ul>
    </section>

    <section>
      <h2>4. Third-Party Sharing</h2>
      <p>We do not sell, rent, or trade your personal data. We only share data with necessary service providers who comply with our privacy standards:</p>
      <ul>
        <li><strong>Helcim:</strong> Payment Processing - Calgary, AB.</li>
        <li><strong>Mailjet:</strong> Email Delivery.</li>
      </ul>
    </section>

    <section>
      <h2>5. Security</h2>
      <p>We employ industry-standard security measures, including:</p>
      <ul>
        <li>Full SSL/TLS encryption for all traffic.</li>
        <li>JWT-based session authentication.</li>
        <li>Firewalled database (Neo4j) and sovereign storage (OVHcloud).</li>
      </ul>
    </section>

    <section>
      <h2>6. Your Rights</h2>
      <p>You have the right to access, correct, or delete your personal data. To request account deletion and the permanent removal of your data from our sovereign storage (The "Right to be Forgotten"), please contact us at support@appwafn.ca.</p>
    </section>

    <section>
      <h2>Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact AppWafn Support at support@appwafn.ca.</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PrivacyView'
}
</script>

<style scoped>
.legal-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  line-height: 1.6;
  color: #333;
  text-align: left;
}

h1 {
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
}

h2 {
  margin-top: 30px;
  color: #2c3e50;
}

ul {
  padding-left: 20px;
}

section {
  margin-bottom: 20px;
}
</style>
